import { useEffect, useMemo, useState } from "react";
import { commonApiServices } from "../../services/api/Common";
import { GetCountriesListData } from "../../services/models/GetCountriesList";

function AccessInfoBadges() {
  const [ip, setIp] = useState("");
  const [ipCountryCode, setIpCountryCode] = useState("");
  const [ipCountryName, setIpCountryName] = useState("");
  const [countries, setCountries] = useState<GetCountriesListData[]>([]);
  const [loadingAccess, setLoadingAccess] = useState(true);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      setLoadingAccess(true);
      const [ipResult, countriesResult] = await Promise.allSettled([
        commonApiServices.getCountryFromIp(),
        commonApiServices.getCountriesList(),
      ]);
      if (cancelled) return;

      if (ipResult.status === "fulfilled") {
        setIp(ipResult.value.data?.ip || "");
        setIpCountryCode(ipResult.value.data?.countryCode || "");
        setIpCountryName(ipResult.value.data?.country || "");
      }
      if (countriesResult.status === "fulfilled") {
        setCountries(countriesResult.value.data || []);
      }
      setLoadingAccess(false);
    };

    load();
    return () => {
      cancelled = true;
    };
  }, []);

  const accessCountry = useMemo(() => {
    const needles = [ipCountryCode, ipCountryName]
      .map((value) => value.toLowerCase().trim())
      .filter(Boolean);
    if (!needles.length) return undefined;
    return countries.find((country) => {
      const short = country.countryShort?.toLowerCase();
      const short2 = country.countryShort2?.toLowerCase();
      const name = country.country.toLowerCase();
      return (
        (short && needles.includes(short)) ||
        (short2 && needles.includes(short2)) ||
        needles.includes(name)
      );
    });
  }, [countries, ipCountryCode, ipCountryName]);

  const countryLabel = accessCountry?.country || "";

  return (
    <div className="flex flex-wrap items-center gap-[8px] mt-[16px]">
      <div className="inline-flex items-center px-[12px] py-[6px] rounded-full border border-[#1418A8] text-[#1418A8] text-[11px] font-medium">
        Access From: {loadingAccess ? "..." : ip || "—"}
      </div>
      <div className="inline-flex items-center gap-[6px] px-[12px] py-[6px] rounded-full border border-[#1418A8] text-[#1418A8] text-[11px] font-medium">
        Access Country:
        {accessCountry?.countryImg ? (
          <img
            src={accessCountry.countryImg}
            alt={countryLabel}
            className="w-[14px] h-[14px] rounded-full object-cover"
          />
        ) : null}
        <span>{loadingAccess ? "..." : countryLabel || "—"}</span>
      </div>
    </div>
  );
}

export default AccessInfoBadges;
